import { useCallback, useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import SimpleTable from "../../../components/SimpleTable";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Utils/Baseurl";
import { Stack } from "@mui/material";


const MomTask = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const currentUser = sessionStorage.getItem("currentUser");

  const getEmplyoeeList = useCallback(async () => {
    setIsLoading(true);
    const formdata = {
      user_id: currentUser,
    };
    try {
      const response = await postData("api/getmeetingtaskbyuser/", formdata);
      console.log(response, "response");
      setList(response?.data);
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setList([]);
    } finally {
      setIsLoading(false);
    }
  }, [currentUser]);

  useEffect(() => {
    getEmplyoeeList();
  }, [getEmplyoeeList]);

  const userColumns = [
    { header: "TASK CODE", key: "task_code" },
    { header: "MEETING TITLE", key: "meeting_title" },
    { header: "PROJECT NAME", key: "project_name" },
    { header: "ACTION ITEM", key: "action_item" },
    { header: "TARGET DATE", key: "start_date" },
    { header: "STATUS", key: "status" },
    { header: "ACTION", key: "action" },
  ];

  // Table row data
  const userData = list.map((item) => ({
    id: item?.id,
    task_code: item?.task_code,
    meeting_title: item?.meeting_title,
    project_name: item?.project_name,
    action_item: item?.action_item,
    start_date: item?.start_date,
    status: item?.status,
    allData: item,
  }));

  // edit function
  const employeeEdit = (id, row) => {
    navigate("/create-meeting/add-meeting", {
      state: { data: row, type: "edit" },
    });
  };
  // view function
  const employeeView = (id, row) => {
    navigate("/meeting-task/mom-view", {
      state: { data: row, type: "view" },
    });
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Action Items
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the Mom Task list here.
          </MaterialTypography>
        </Stack>
      </Stack>

      <SimpleTable
        columns={userColumns}
        data={userData}
        onEdit={employeeEdit}
        edit={false}
        deleteAction={false}
        onView={employeeView}
        isLoading={isLoading}
        download={false}
      />
    </DashboardLayout>
  );
};

export default MomTask;
